import { IframeResizer } from '@open-iframe-resizer/react'
import cn from 'classnames'

type Props = {
  aspect?: string
  src: string
  title: string
}

export default function Iframe({ aspect, src, title }: Props) {
  if (aspect) {
    const className = cn('h-full w-full', {
      'aspect-square sm:aspect-[10/4]': aspect === 'sm:10/4',
      'aspect-[10/3]': aspect === '10/3'
    })

    return <iframe className={className} src={src} title={title} />
  }

  return <IframeResizer className='h-0 w-full' src={src} title={title} />
}

Iframe.scheme = {
  render: 'Iframe',
  attributes: {
    aspect: { type: String },
    src: { type: String, required: true },
    title: { type: String, required: true }
  }
}
